import { Country } from '@sharedModule/models/country.model';

export const COUNTRY_STATE = 'countries';

export interface CountryState {
  isLoading: boolean;
  data: Country[];
  error?: string;
}

export const initialCountryState: CountryState = Object.freeze({
  isLoading: false,
  data: [],
  error: '',
});
